/**
 * ThemeToggle — GLOBAL SNIPPET (owner-mandated iter 240)
 *
 * The ONE light/dark toggle used across every module (Directory, Recipes,
 * Property, SiteLayout, Portal). Do NOT fork or duplicate — extend props
 * on this file instead. See /app/memory/AGENT_RULES.md.
 *
 * Behaviour:
 *   - Backed by `useTheme()` (localStorage["hp-theme"] + prefers-color-scheme).
 *   - Sets BOTH `data-theme="dark"` (property CSS vars) AND `class="dark"`
 *     (Tailwind darkMode: class) on <html>. Both stay in lockstep.
 *   - Sun ↔ Moon icon, pill button, works on light + dark chrome.
 */
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../hooks/useTheme";
import Tip from "./Tip";

export default function ThemeToggle({
  size = 16,
  testid = "theme-toggle",
  className = "",
}) {
  const { isDark, toggle } = useTheme();
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";
  return (
    <Tip label={label} side="bottom">
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      data-testid={testid}
      className={
        "inline-flex items-center justify-center h-9 w-9 rounded-full " +
        "border border-stone-200 dark:border-stone-700 " +
        "bg-white/70 dark:bg-stone-800/70 " +
        "text-stone-700 dark:text-amber-300 " +
        "hover:bg-stone-100 dark:hover:bg-stone-700 " +
        "transition-colors " +
        className
      }
    >
      {isDark ? <Sun size={size} strokeWidth={1.75} /> : <Moon size={size} strokeWidth={1.75} />}
    </button>
    </Tip>
  );
}
